import { render, staticRenderFns } from "./InvoiceAdditionalText.vue?vue&type=template&id=68a2a7d0&"
import script from "./InvoiceAdditionalText.vue?vue&type=script&lang=js&"
export * from "./InvoiceAdditionalText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports